import { BehaviorSubject } from "rxjs";
import { debounceTime, filter } from "rxjs/operators";

export class ScrollSpySingleton {
  static instance;

  constructor() {
    if (ScrollSpySingleton.instance) {
      return ScrollSpySingleton.instance;
    }

    this._intersections$ = new BehaviorSubject([]).pipe(
      debounceTime(100),
      // Filter out empty arrays to avoid processing when there are no entries
      filter((entriesArray) => entriesArray.length === 1),
    );
    // Apply debounceTime to ensure only the last event within 500ms is emitted
    this._intersections$.subscribe((entriesArray) =>
      this.processIntersections(entriesArray),
    );

    this.observer = this.createObserver();
    ScrollSpySingleton.instance = this;
  }

  createObserver() {
    const observerOptions = {
      root: document.querySelector("#stage-view"),
      rootMargin: "210px 0px 0px 0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      // Directly pass entries to the BehaviorSubject
      //console.log("ENTRIES ", {entries}, this._intersections$);
      this._intersections$.next(entries);
    }, observerOptions);

    return observer;
  }

  processIntersections(entriesArray) {
    // Since debounceTime is used, entriesArray will not be an array of arrays
    entriesArray.forEach((entry) => {
      if (entry.isIntersecting) {
        //console.log("intersecting is ",this,entry?.target)
      }
    });
  }

  addSectionObserver(sectionNode) {
    this.observer.observe(sectionNode);
  }

  removeSectionObserver(sectionNode) {
    this.observer.unobserve(sectionNode);
  }

  // Getter method to access the intersections$ observable
  get intersections$() {
    return this._intersections$;
  }
}
